import { useEffect, useRef, useState } from "react";
import { WhatsappIcon, WhatsappShareButton } from "react-share";
import { getReceiptUrls } from "../../../../utils/MenuUtils";
import classes from "./ShareButtons.module.css";

const Whatsapp = (props) => {
  const [url, setUrl] = useState("none");
  const shareButton = useRef(null);

  const onShareClick = async () => {
    if (url === "none") {
      const selectedInvoiceSummaries = props.getSelectedValues(props.parkingHistoryId);
      let message = await getReceiptUrls(selectedInvoiceSummaries);
      setUrl(message);
    }
  };

  useEffect(() => {
    if (url && url !== "none") {
      shareButton.current?.click();
      setUrl("none");
    }
  }, [url, shareButton]);
  
  return (
    <WhatsappShareButton
      className={classes.shareButton}
      url={url}
      ref={shareButton}
      openShareDialogOnClick={url !== "none"}
      title="Whatsapp Share"
      onClick={onShareClick}
    >
      <WhatsappIcon size={32} round={true} />
    </WhatsappShareButton>
  );
};

export default Whatsapp;
